import actions from './actions'
import { factoryReducer } from '../factory'

// Defining the Initial Variables to be saved in the Redux Store on initialize.
const initialState = {
  filteredType: '',
  activeMembers: [],
  members: [],
  allMembers: [],
  allSharedMembers: [],
  sharedMembers: [],
  loading: false,
  newMembers: '',
  memberUpdated: '',
  totalSleepSessions: '-',
  memberDetail: {},
  setStatusLoading: false,
  formLoading: false,
  redirect: false,
  acmAPIs: [],
  saAccess: [],
  vcAdminAccess: [],
  memberAccess: [],
  acmLoading: false,
  providerDetail: {},
  providerMembersloading: false,
  providerActiveMembers: [],
  providerMembers: [],
  providerSharedMembers: [],
  providerTotalSleepSessions: '-',
  lastFormValues: {},
  userList: [],
  userListLoading: false,
  userListPagination: null,
  userListFilters: null,
  userDetail: {},
  userDetailLoading: false,
  userLoginHistory: [],
  userLoginHistoryLoading: false,
  memberDeleted: '',
  loadingInTransferClinicModal: false,
  userClinics: [],
  facilityAssignedStatus: '',
  pccMembers: [],
  pccMembersLoading: false,
  pccMembersPagination: null,
  pccMembersFilters: null,
}

export default factoryReducer(initialState, actions)
